(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("three"));
	else if(typeof define === 'function' && define.amd)
		define(["three"], factory);
	else if(typeof exports === 'object')
		exports["ThickLine"] = factory(require("three"));
	else
		root["ThickLine"] = factory(root["THREE"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__815__) {
return 